import { createContext, useRef } from "react";
import PropTypes from "prop-types";
import { Outlet, useNavigate } from "react-router-dom";
import axios from "axios";
import { usePatientFacing } from "../../../flow/patientFacing/hooks/usePatientFacing";
import { postAnalytics } from "../../../../PatientComponents/analytics";

export const questionnaireContext = createContext();

export default function QuestionnaireProvider({
  redirectPath = "../gi/Video",
  analyticsFacingType = "gi",
}) {
  const { getEventDataLocal } = usePatientFacing();
  const event = getEventDataLocal();
  const caseId = event?.Case?.id;

  const answers = useRef({});
  const navigate = useNavigate();

  const updateAnswer = ({ questionKey, answerKey }) => {
    answers.current[questionKey] = answerKey;
  };

  const submit = () => {
    axios.post("/api/user/updateQuestionnaire", { caseId, data: answers.current });
    postAnalytics(caseId, "answered-questionnaire", undefined, analyticsFacingType);

    // Merge fresh answers into the locally-cached event so the next page
    // (GIVideo / MedicinesChanges) sees the updated GiCase immediately,
    // without waiting for a re-fetch.
    const currentEvent = getEventDataLocal();
    if (currentEvent?.Case) {
      const now = new Date().toISOString();
      const cpData = currentEvent.Case.CasesProgresses;
      const cpArray = Array.isArray(cpData)
        ? [...cpData]
        : (cpData ? [cpData] : []);
      const progressIndex = cpArray.findIndex(
        (cp) => cp?.facingType === analyticsFacingType
      );
      const updatedProgress = progressIndex >= 0
        ? {
            ...cpArray[progressIndex],
            answeredQuestionnaire:
              cpArray[progressIndex]?.answeredQuestionnaire || now,
          }
        : { facingType: analyticsFacingType, answeredQuestionnaire: now };
      if (progressIndex >= 0) {
        cpArray[progressIndex] = updatedProgress;
      } else {
        cpArray.push(updatedProgress);
      }

      const mergedEvent = {
        ...currentEvent,
        Case: {
          ...currentEvent.Case,
          GiCase: {
            ...(currentEvent.Case.GiCase || {}),
            ...answers.current,
          },
          CasesProgresses: cpArray,
        },
      };
      sessionStorage.setItem("eventData", JSON.stringify(mergedEvent));
    }

    navigate(redirectPath);
  };

  return (
    <questionnaireContext.Provider value={{ updateAnswer, submit, answers }}>
      <Outlet />
    </questionnaireContext.Provider>
  );
}

QuestionnaireProvider.propTypes = {
  children: PropTypes.node,
  redirectPath: PropTypes.string,
  analyticsFacingType: PropTypes.string,
};
